import { Link } from "react-router-dom";
import { ArrowRight, BookOpen } from "lucide-react";
import { EBOOK, track } from "@/lib/ebook";

export default function EbookBanner() {
  return (
    <section
      data-testid="ebook-banner"
      className="relative z-10 border-y border-[#D4AF37]/20 overflow-hidden"
    >
      <div
        className="absolute inset-0 opacity-30"
        style={{
          background:
            "radial-gradient(ellipse 50% 80% at 20% 50%, rgba(212, 175, 55, 0.25), transparent 60%), radial-gradient(ellipse 60% 80% at 90% 50%, rgba(130, 73, 55, 0.35), transparent 60%)",
        }}
        aria-hidden
      />
      <div className="relative max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16 py-16 md:py-24 grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        {/* Cover */}
        <div className="lg:col-span-4 order-2 lg:order-1">
          <div className="relative group max-w-[280px] mx-auto lg:max-w-full">
            <div className="absolute -inset-2 bg-[#D4AF37]/10 blur-xl group-hover:bg-[#D4AF37]/20 transition-colors" aria-hidden />
            <div className="relative border border-[#D4AF37]/40 overflow-hidden aspect-[3/4]">
              <img
                src={EBOOK.cover}
                alt="The Crowned Perfect Photo Guide — free artwork selection guide cover"
                loading="lazy"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent" />
              <div className="absolute inset-x-4 bottom-4">
                <p className="overline text-[#D4AF37]">Free Crowned Guide</p>
                <p className="font-serif-display text-white text-base leading-tight mt-2">
                  The Crowned Perfect Photo Guide
                </p>
              </div>
              <div className="absolute top-4 right-4 bg-[#D4AF37] text-black overline px-2.5 py-1">
                Free
              </div>
            </div>
          </div>
        </div>

        {/* Copy + CTA */}
        <div className="lg:col-span-8 order-1 lg:order-2">
          <div className="inline-flex items-center gap-2 overline text-[#D4AF37]">
            <BookOpen className="w-3.5 h-3.5" />
            Free — The Crowned Perfect Photo Guide
          </div>
          <h2 className="font-serif-display text-3xl md:text-4xl lg:text-5xl leading-[1.05] mt-5">
            Before we create the masterpiece,<br />
            <span className="italic text-[#D4AF37]">let&apos;s find the right photo.</span>
          </h2>
          <p className="text-white/70 mt-6 max-w-2xl font-light leading-relaxed">
            Your photograph is the foundation of your finished artwork. The
            Crowned Perfect Photo Guide helps you understand what makes a
            photograph stronger for custom artwork before you submit it.
          </p>
          <div className="mt-8">
            <Link
              to="/ebook"
              onClick={() => track("ebook_cta", "home-banner")}
              data-testid="ebook-banner-cta"
              className="group inline-flex items-center gap-3 bg-[#D4AF37] text-black px-7 py-4 text-xs uppercase tracking-[0.22em] font-semibold hover:bg-[#e6c245] transition-all"
            >
              Get The Free Photo Guide
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
